export const tableDataOeeFields = [
    'actOutput',
    'engReject',
    'prdReject',
    'machineDown',
    'machineEquipment',
    'mouldBreakdown',
    'jigFixture',
    'engineeringBuild',
    'machineSupportDoc',
    'manpower',
    'facility',
    'materialDelay',
    'materialNotAvailable',
    'unplanBriefing',
];

export const tableDataProductivityFields = [
    'actOutput',
    'engReject',
    'prdReject',
];

export function toTableDataNumber(value) {
    if (value === null || value === undefined || value === '') {
        return 0;
    }

    const numberValue = Number(value);
    return Number.isFinite(numberValue) ? numberValue : 0;
}

export function getTableDataOeeTotal(row = {}) {
    return tableDataOeeFields.reduce((total, field) => total + toTableDataNumber(row[field]), 0);
}

function getRoundedPercent(numerator, denominator) {
    if (!denominator) {
        return 0;
    }

    return Math.round((numerator / denominator) * 100);
}

export function calculateTableDataMetrics(row = {}) {
    const oeeTotal = getTableDataOeeTotal(row);
    const productivityTotal = tableDataProductivityFields.reduce(
        (total, field) => total + toTableDataNumber(row[field]),
        0
    );
    const planOutput = toTableDataNumber(row.planOutput);

    return {
        oee: getRoundedPercent(toTableDataNumber(row.actOutput), oeeTotal),
        productivity: getRoundedPercent(productivityTotal, planOutput),
    };
}
